/* eslint-disable no-undef */
/**
 * Sitecore entry point for the chat widget (confused.com only).
 *
 * This file is NOT a standalone module and cannot be imported. Gulp concatenates it onto
 * the end of _main.js (see `askConfusedAiList` in gulp/variables.js), so `ChatInterface`
 * arrives from that shared scope rather than an import. This is the same idiom
 * shared.min.js relies on, and it is why there is no import statement here.
 *
 * It behaves exactly as the block that used to sit at the bottom of _main.js: find the
 * markup the Razor view rendered and read config off its data- attributes.
 *
 * Why it is a separate file: _main.js has to stay free of side effects, because
 * confusedcom/webex-askconfused-widget holds a byte-identical copy of it as the source of
 * truth and mounts the class explicitly. This auto-init is confused.com-only, so it cannot
 * live in the shared file. See ASK-90.
 *
 * Order note: this is concatenated after _main.js, but it does not depend on that. The
 * only reference to ChatInterface is inside the event callback, which runs long after the
 * whole concatenated module has evaluated.
 */
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.mod-ask-confused-ai').forEach(container => {
		const apiUrl = container.dataset.apiUrl || 'http://localhost:8000/orchestrator';
		const apiSubKey = container.dataset.apiKey || '';
		const userJwt = container.dataset.userJwt || '';
		new ChatInterface({ apiUrl, apiSubKey, userJwt, container });
	});
});
